import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ReactEcharts from 'echarts-for-react';

//Start Css Code ....
const useStyles = makeStyles((theme) => ({
    countsTabMain: {
        height: '100%',
        width: '100%',
        float: 'left',
        background: '#fff',
        top: '2%',
        zIndex: '1',
        '& h4': {
            fontSize: '20pt',
            margin: '0',
            color: '#24618E',
            marginTop: '30px',
        },
        '& .MuiPaper-elevation2': {
            boxShadow: 'none',
        },
        '& .focus': {
            background: '#24618E',
            color: "#fff !important",
            fontWeight: '600',
        },
    },
    tempGrapImage: {
        float: 'left',
        '@media only screen and (max-width: 1279px)': {
            width: '100%',
            height: '620px',
            '& .echarts-for-react': {
                height: '600px !important',
            }
        },
        '@media only screen and (min-width: 1280px) and (max-width: 1439px)': {
            width: '90%',
            height: '620px',
            '& .echarts-for-react': {
                height: '600px !important',
            }
        },
        '@media only screen and (min-width: 1440px) and (max-width: 2400px)': {
            width: '90%',
            height: '620px',
            '& .echarts-for-react': {
                height: '600px !important',
            }
        },
        '@media only screen and (min-width: 2401px) and (max-width: 3500px)': {
            width: '90%',
            height: '900px',
            '& .echarts-for-react': {
              height: '875px !important',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            marginTop: '25px',
            width: '90%',
            height: '1220px',
            '& .echarts-for-react': {
                height: '1200px !important',
            }
        }
    },
    combinedTableBlock: {
        width: '100%',
        float: 'left',
        marginBottom: '10px',
        '& .mainDivBlock': {
            width: '60%',
            float: 'left',
            marginLeft: '10%',
        },
        '& .blockDiv': {
            width: '33.33%',
            float: 'left',
            padding: '0 30px',
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        }
    },
    tableHead: {
        fontWeight: 'bolder',
        textAlign: 'center',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    tableHeadSimple: {
        fontWeight: 'normal',
        textAlign: 'center',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    titleTD: {
        textAlign: 'left',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    dataTD: {
        textAlign: 'center',
        padding: 0,
        '@media only screen and (max-width: 3500px)': {
            fontSize: '12pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '22pt',
        },
    },
    tableMidBlock: {
        '& td': {
            border: '1px solid #D7D7D7',
            padding: '5px'
        },
        '& th': {
            border: '1px solid #D7D7D7',
            '@media only screen and (max-width: 3500px)': {
                padding: '5px',
            },
            '@media only screen and (min-width: 3501px)': {
                padding: '10px 5px',
            },
        },
        '& tbody.MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)': {
            backgroundColor: ' #f2f2f2 !important',
        },
    },

}));
//End Css Code ....

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


//Start MidVolumeSB component code ...
const MidVolumeSB = props => {
    const classes = useStyles();
    const theme = useTheme();
    const [myOptions, setmyOptions] = React.useState({})
    const [getAmTimeData, setAmTimeData] = React.useState([]);
    const [getGraphData, setGraphData] = React.useState([]);
    const [getCountData, setCountData] = React.useState([]);
    const [getTotalCount, setTotalCount] = React.useState(0);
    const [getTotalCountPm, setTotalCountPM] = React.useState([]);
    const [timeArr, setTimeArr] = React.useState([
        '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM',
        '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM']);

    const [timeArrAm, setTimeArrAm] = React.useState([
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM',
        '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',]);

    const [defaultTimeArray, setDefaultTimeArray] = React.useState([
        '12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM', '5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM', '10:00 PM', '11:00 PM'])

    React.useEffect(() => {
        if (props.data != undefined) {
            let arrayCountAm = [];
            let arrayCountPm = [];
            let graphCountData = [];
            props.data.count.map((valueCount, countIndex) => {
                graphCountData.push(valueCount.count);
            })
            setGraphData(graphCountData);
            myOptionFunction(graphCountData);

            for (let index = 0; index < props.data.count.length; index++) {
                if (props.data.count[index].key.includes("AM")) {
                    arrayCountAm.push(props.data.count[index]);
                } else if (props.data.count[index].key.includes("PM")) {
                    arrayCountPm.push(props.data.count[index]);
                }
            }

            let sortDateAm = [];
            let sortDatePm = [];
            
            setTotalCountPM(arrayCountPm);
            setCountData(arrayCountAm);
            setTotalCount(props.data.totalCount);
        } else {
            setCountData([]);
            setTotalCountPM([]);
            setTotalCount(0);
        }

    }, [props.data])


//This method is use for create echart ... start
    function myOptionFunction(graphCountData) {
        setmyOptions({
            xAxis: {
                data: props.data && props.data.startTime.length > 0 ? props.data.startTime : defaultTimeArray,
                axisLabel: {
                    rotate: 45,
                    fontSize: 15,
                    fontSize: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? 13 : sessionStorage.getItem('midTabWidth') >= 3501 ? 24 : 12,
                },
                splitLine: {
                    show: true
                },               
                type: 'category',
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    show: false,
                    type: 'none'
                },
                textStyle: {
                    fontSize: sessionStorage.getItem('midTabWidth') >= 3501 ? 30 : 14,
                }
            },
            grid: {
                height: 'auto',
                top: '20px',
                left: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? '40px' : sessionStorage.getItem('midTabWidth') >= 3501 ? '100px' : '40px',
                right: '15px',
                bottom: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? '50px' : sessionStorage.getItem('midTabWidth') >= 3501 ? '120px' : '50px',
            },
            yAxis: {
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: true
                },
                axisLabel: {
                    // fontSize: sessionStorage.getItem('midTabWidth') >= 1200 && sessionStorage.getItem('midTabWidth') <= 3500 ? 13 : sessionStorage.getItem('midTabWidth') >= 3501 ? 24 : 12,
                    fontSize: Math.max(...graphCountData).toString().length >= 4 ? 10 : 13
                },                
            },
            series: [
                {
                    type: 'bar',
                    itemStyle: {
                        color: "#5C9CEC",
                    },
                    barWidth: '25px',
                    data: graphCountData,
                }
            ]
        })
    }
    //This method is use for create echart ... end


    return (
        <React.Fragment>
            <div className={classes.countsTabMain}>
                <div className={classes.tempGrapImage}>
                    {myOptions && <ReactEcharts option={myOptions} />}
                </div>
                <div className={classes.combinedTableBlock}>
                    <div className='mainDivBlock'>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead}>Start Time</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Count</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {
                                            getCountData.map((value, index) => {
                                                return (
                                                    <StyledTableRow key={index}>
                                                        <TableCell align="right" className={classes.dataTD}>{value.key}</TableCell>
                                                        <TableCell align="right" className={classes.dataTD}>{typeof (value.count) === "number" ? value.count : '--'}</TableCell>
                                                    </StyledTableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead}>Start Time</TableCell>
                                            <TableCell align="right" className={classes.tableHead}>Count</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {
                                            getTotalCountPm.map((eleValue, index) => {
                                                return (
                                                    <StyledTableRow key={index}>
                                                        <TableCell align="right" className={classes.dataTD}>{eleValue.key}</TableCell>
                                                        <TableCell align="right" className={classes.dataTD}>{typeof (eleValue.count) === "number" ? eleValue.count : '--'}</TableCell>
                                                    </StyledTableRow>
                                                )
                                            })
                                        }

                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </div>
                        <div className='blockDiv'>
                            <TableContainer component={Paper}>
                                <Table className={classes.tableMidBlock} aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right" className={classes.tableHead}>Total</TableCell>
                                            <TableCell align="right" className={classes.tableHeadSimple}>{typeof (getTotalCount) === "number" ? getTotalCount : '--'}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MidVolumeSB;
//End MidVolumeSB component code ...